import { render } from "./CourseContentHeaderComponent.vue?vue&type=template&id=1c4f4e55&scoped=true"
import script from "./CourseContentHeaderComponent.vue?vue&type=script&lang=js"
export * from "./CourseContentHeaderComponent.vue?vue&type=script&lang=js"

import "./CourseContentHeaderComponent.vue?vue&type=style&index=0&id=1c4f4e55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4f4e55"]])

export default __exports__